import { Slide } from "react-slideshow-image";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faUserTie,
  faUserFriends,
  faTableTennis,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";

import "./Metric.css";

export const Metrics = (props) => {
  const { data } = props;
  const { t } = useTranslation();
  const [slidesToShow, setSlidesToShow] = useState(2);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth < 1000) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    handleResize(); // Initial call to set the correct value on load
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div className="metrics">
        <div className="metrics-info home-info">
          <h3>{t("metric")}</h3>
        </div>
      </div>
      <div className="metrics-container">
        <Slide
          slidesToScroll={2}
          indicators={true}
          slidesToShow={slidesToShow}
          arrows={false}
        >
          <div className="slide">
            <div className="slideData">
              <div className="metric-icon players-icon">
                <FontAwesomeIcon icon={faTableTennis} />
              </div>
              <div className="card-info">
                <h3>{t("totalplayer")}</h3>
                <p className="card-info-main">{data?.totalPlayers || 0}</p>
              </div>
              {/* <p className="update-date">Last updated {data?.last_update}</p> */}
            </div>
          </div>
          <div className="slide">
            <div className="slideData">
              <div className="metric-icon women-icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <div className="card-info">
                <h3>{t("totalwomen")}</h3>
                <p className="card-info-main">{data?.womenPlayers || 0}</p>
              </div>
              {/* <p className="update-date">Last updated {data?.last_update}</p> */}
            </div>
          </div>
          <div className="slide">
            <div className="slideData">
              <div className="metric-icon active-players-icon">
                <FontAwesomeIcon icon={faUserCheck} />
              </div>
              <div className="card-info">
                <h3>{t("activeplayer")}</h3>
                <p className="card-info-main">
                  {data?.monthlyActivePlayers ?? 0}
                </p>
              </div>
            </div>
          </div>
          <div className="slide">
            <div className="slideData">
              <div className="metric-icon coach-icon">
                <FontAwesomeIcon icon={faUserTie} />
              </div>
              <div className="card-info">
                <h3>{t("totalcoach")}</h3>
                <p className="card-info-main">{data?.totalCoaches || 0}</p>
              </div>
              {/* <p className="update-date">Last updated {data?.last_update}</p> */}
            </div>
          </div>
          <div className="slide">
            <div className="slideData">
              <div className="metric-icon groups-icon">
                <FontAwesomeIcon icon={faUserFriends} />
              </div>
              <div className="card-info">
                <h3>{t("totalgrp")}</h3>
                <p className="card-info-main">{data?.totalTrainingGroups || 0}</p>
              </div>
              {/* <p className="update-date">Last updated {data?.last_update}</p> */}
            </div>
          </div>
        </Slide>
      </div>
    </>
  );
};
